/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import axios from "axios";
import { saveAs } from "file-saver";

import { errorHandler, options } from "./index";
import types from "../actions/types";
import { API_URL } from "../config";
import getTheUserState from "../utils/userState";
import IsUserUnauthorized from "../utils/unauthorized";
import { toast_notifications } from "../utils/notifications";

const userState = getTheUserState();
const token = userState?.token;

const allowedOrigins =
  "http://localhost:3000,http://localhost:3001,http://motcos.com,http://localhost:8090,http://motcos.tvm-engineering.com";

export function putTermsAndConditions(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsAndConditions/updateTermsAndConditions", body, "put")
      ).catch((error) => {
        if (error.response) {
          const status = error?.response?.status;
          IsUserUnauthorized(status);
        }
      });
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Successfully update terms!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function createTermsAndConditions(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsAndConditions/createTermsAndConditions", body, "post")
      ).catch((error) => {
        if (error.response) {
          const status = error?.response?.status;
          IsUserUnauthorized(status);
        }
      });
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Successfully created Terms and Conditions!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getAllTermsAndConditions(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsAndConditions/getAllTermsAndConditions", body, "get")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        dispatch({
          type: types.GET_ALL_TERMS_AND_CONDITIONS,
          payload: response.data,
        });
        // dispatch(actions.showNotification('Successfully created terms!', true));
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function postAllTermsAndConditions() {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsAndConditions/postAllTermsAndConditions", {}, "post")
      ).catch((error) => {
        if (error.response) {
          const status = error?.response?.status;
          IsUserUnauthorized(status);
        }
      });
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        dispatch({
          type: types.GET_ALL_TERMS_AND_CONDITIONS,
          payload: response.data,
        });
        // dispatch(actions.showNotification('Successfully created terms!', true));
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function deleteTermsAndConditions(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsAndConditions/deleteTermsAndConditions", body, "post")
      ).catch((error) => {
        if (error.response) {
          const status = error?.response?.status;
          IsUserUnauthorized(status);
        }
      });
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        toast_notifications.success("Successfully deleted the Term and its coresponding versions!");
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getTermsByName(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsAndConditions/getTermsByName", body, "post")
      );
      return response.data;
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getTermsAndConditionsVersions(body) {
  return async (dispatch) => {
    try {
      const response = await axios(
        options(API_URL + "/termsVersion/getTermsAndConditionsVersions", body, "get")
      );
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        dispatch({
          type: types.GET_ALL_TERMS_AND_CONDITIONS_VERSIONS,
          // payload: response.data,
        });
        // dispatch(actions.showNotification('Successfully created terms!', true));
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export async function setGeneralVersion(body, type) {
  const obj = { data: body, type };
  axios(options(API_URL + "/termsAndConditions/setGeneralVersion", obj, "post")).catch((error) => {
    if (error.response) {
      const status = error?.response?.status;
      IsUserUnauthorized(status);
    }
  });
  // return async (dispatch) => {
  //   try {
  //     const response = await axios(
  //       options(API_URL + "/termsAndConditions/setGeneralVersion", data, "post")
  //     );
  //     const responseOK = response && response.status === 200 && response.statusText === "OK";
  //     if (responseOK) {
  //       dispatch(actions.showNotification("Successfully delete Term Version!", true));
  //     }
  //   } catch (error) {
  //     console.warn("Error:", error);
  //     dispatch(errorHandler(error));
  //   }
  // };
}

export async function getArchivedTerms() {
  const response = await axios(options(API_URL + "/getArchivedTerms", {}, "get")).catch((error) => {
    if (error.response) {
      const status = error?.response?.status;
      IsUserUnauthorized(status);
    }
  });
  const responseOK = response && response.status === 200 && response.statusText === "OK";
  if (responseOK) {
    // dispatch({
    //   type: types.GET_ALL_TERMS_AND_CONDITIONS_VERSIONS,
    //   // payload: response.data,
    // });
    // dispatch(actions.showNotification('Successfully created terms!', true));
    return response.data;
  }
}

export async function downloadArchivedTerm(termName) {
  try {
    const response = await axios({
      url: API_URL + "/downloadArchivedTerm",
      method: "POST",
      responseType: "blob",
      headers: {
        Authorization: token,
        "Access-Control-Allow-Origin": allowedOrigins,
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Content-Type-Options": "nosniff",
        credentials: "same-origin", // include, same-origin, *omit
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        withCredentials: true,
        withAuthentication: true,
      },
      data: {
        termName,
      },
    });

    const responseOK = response && response.status === 200 && response.statusText === "OK";
    if (responseOK) {
      const fileName = response.headers["content-disposition"].substring(21, 70);
      const blob = new Blob([response.data], { type: "application/*;charset=utf-8" });
      saveAs(blob, fileName);
      return true;
    }
  } catch (error) {
    console.log(error);
  }
}

export async function getAllTerms() {
  const response = await axios(options(API_URL + "/terms/getAllTerms", {}, "get")).catch(
    (error) => {
      if (error.response) {
        const status = error?.response?.status;
        IsUserUnauthorized(status);
      }
    }
  );
  const responseOK = response && response.status === 200 && response.statusText === "OK";
  if (responseOK) {
    // dispatch({
    //   type: types.GET_ALL_TERMS_AND_CONDITIONS_VERSIONS,
    //   // payload: response.data,
    // });
    // dispatch(actions.showNotification('Successfully created terms!', true));
    return response.data;
  }
}

export async function getTermsInCompanies() {
  const response = await axios(options(API_URL + "/terms/getTermsInCompanies", {}, "get")).catch(
    (error) => {
      if (error.response) {
        const status = error?.response?.status;
        IsUserUnauthorized(status);
      }
    }
  );
  const responseOK = response && response.status === 200 && response.statusText === "OK";
  if (responseOK) {
    // dispatch({
    //   type: types.GET_ALL_TERMS_AND_CONDITIONS_VERSIONS,
    //   // payload: response.data,
    // });
    // dispatch(actions.showNotification('Successfully created terms!', true));
    return response.data;
  }
}

export async function getGeneralTerms(companies) {
  try {
    const response = await axios(options(API_URL + `/general-terms/${companies}`, {}, "get"));
    const responseOK = response && response.status === 200 && response.statusText === "OK";
    if (responseOK) {
      return response.data;
    }
  } catch (err) {
    console.log(err);
  }
}

export const termsAndConditionsService = {
  getAllTerms: () => axios(options(API_URL + "/terms/getAllTerms", {}, "get")),
  getTermById: (data) => axios(options(API_URL + `/terms/${data}`, {}, "get")),
  updateTerm: (data) =>
    axios(options(API_URL + "/termsAndConditions/updateTermsAndConditions", data, "post")),
  getTermsInCompanies: () => axios(options(API_URL + "/terms/getTermsInCompanies", {}, "get")),
  getTermsInCompaniesByUser: (data) => axios(options(API_URL + "/terms/getTermsInCompaniesByUser", {}, "get", data)),
  createTermsAndConditions: (data) =>
    axios(options(API_URL + "/termsAndConditions/createTermsAndConditions", data, "post")),
  getAllTermsFiltered: () =>
    axios(options(API_URL + "/general-terms/all-terms/all-terms", {}, "get")),
};
